import React, { useCallback, useEffect, useRef, useState } from 'react'
import { withTranslation } from 'react-i18next'
import withRouter from '../../components/Common/withRouter'
import {
  getLabRecord as onGetLabRecord,
  getAllLabRemarks as onGetAllLabRemarks,
  getAllLabSamples as onGetAllLabSamples,
  createLabTests as onCreateLabTests
} from "../../slice/thunks"
import { createSelector } from "reselect"
import { useSelector, useDispatch } from "react-redux"
import GlobalLoader from '../../components/Common/GlobalLoader'
import { Link, useNavigate, useParams } from "react-router-dom"
import { useReactToPrint } from 'react-to-print';
import TestsRow from '../../components/App/LabRecords/TestsRow'
import DeleteModal from '../../components/Global/DeleteModal'
import { Col, Modal, ModalBody, ModalFooter, Row } from 'reactstrap'
import logo from "../../assets/images/HMS-Logo.png"

import moment from 'moment'

const RecordBackup = (props) => {
    
}

export default withRouter(withTranslation()(RecordBackup))
